import { createSlice } from '@reduxjs/toolkit';
import { getCustomers, getSalePaymnets, getSaleQuantitybyBrand, getTicketCount, getWinners } from './dashboardService';

const initialState = {
    saleQuantitybyBrand: {
        isSaleQuantityLoading: null,
        isSaleQuantitySuccess: null,
        sale: [],
    },
    salePayments: {
        isSalePaymentsLoading: null,
        isSalePaymentsSuccess: null,
        payments: [],
    },
    ticketCount: {
        isCountLoading: null,
        isCountSuccess: null,
        count: 0,
        unsold_count: 0,
    },
    winnersCount: {
        isWinnersLoading: null,
        isWinnersSuccess: null,
        winners: 0,
    },
    customerCount: {
        isCustomersLoading: null,
        isCustomersSuccess: null,
        customers: 0,
    },
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSaleQuantitybyBrand.pending, (state) => {
            state.saleQuantitybyBrand = {
                ...initialState.saleQuantitybyBrand,
                isSaleQuantityLoading: true,
            };
        });

        builder.addCase(getSaleQuantitybyBrand.rejected, (state) => {
            state.saleQuantitybyBrand = {
                ...initialState.saleQuantitybyBrand,
                isSaleQuantityLoading: false,
                isSaleQuantitySuccess: false,
            };
        });

        builder.addCase(getSaleQuantitybyBrand.fulfilled, (state, action) => {
            state.saleQuantitybyBrand = {
                ...initialState.saleQuantitybyBrand,
                isSaleQuantityLoading: false,
                isSaleQuantitySuccess: true,
                sale: action.payload,
            };
        });

        // Sale payment
        builder.addCase(getSalePaymnets.pending, (state) => {
            state.salePayments = {
                ...initialState.salePayments,
                isSalePaymentsLoading: true,
            };
        });

        builder.addCase(getSalePaymnets.rejected, (state) => {
            state.salePayments = {
                ...initialState.salePayments,
                isSalePaymentsLoading: false,
                isSalePaymentsSuccess: false,
            };
        });

        builder.addCase(getSalePaymnets.fulfilled, (state, action) => {
            state.salePayments = {
                ...initialState.salePayments,
                isSalePaymentsLoading: false,
                isSalePaymentsSuccess: true,
                payments: action.payload,
            };
        });

        // Ticket count
        builder.addCase(getTicketCount.pending, (state) => {
            state.ticketCount = {
                ...initialState.ticketCount,
                isCountLoading: true,
            };
        });

        builder.addCase(getTicketCount.rejected, (state) => {
            state.ticketCount = {
                ...initialState.ticketCount,
                isCountLoading: false,
                isCountSuccess: false,
            };
        });

        builder.addCase(getTicketCount.fulfilled, (state, action) => {
            state.ticketCount = {
                ...initialState.ticketCount,
                isCountLoading: false,
                isCountSuccess: true,
                count: action.payload[0].sold_count,
                unsold_count: action.payload[0].unsold_count
            };
        });

        // Winners count
        builder.addCase(getWinners.pending, (state) => {
            state.winnersCount = {
                ...initialState.winnersCount,
                isWinnersLoading: true,
            };
        });

        builder.addCase(getWinners.rejected, (state) => {
            state.winnersCount = {
                ...initialState.winnersCount,
                isWinnersLoading: false,
                isWinnersSuccess: false,
            };
        });

        builder.addCase(getWinners.fulfilled, (state, action) => {
            state.winnersCount = {
                ...initialState.winnersCount,
                isWinnersLoading: false,
                isWinnersSuccess: true,
                winners: action.payload.no_of_winners,
            };
        });

        // Customers count
        builder.addCase(getCustomers.pending, (state) => {
            state.customerCount = {
                ...initialState.customerCount,
                isCustomersLoading: true,
            };
        });

        builder.addCase(getCustomers.rejected, (state) => {
            state.customerCount = {
                ...initialState.customerCount,
                isCustomersLoading: false,
                isCustomersSuccess: false,
            };
        });

        builder.addCase(getCustomers.fulfilled, (state, action) => {
            state.customerCount = {
                ...initialState.customerCount,
                isCustomersLoading: false,
                isCustomersSuccess: true,
                customers: action.payload.no_of_customers,
            };
        });
    },
});

export default dashboardSlice.reducer;
